import {
  body,
  large,
  medium,
  disabled,
  arrow,
} from './style'
import { ButtonProps } from "types"

export const Button = ({onClick, size, children, disable, hasArrow, classname}: ButtonProps) => {
  return (
    <div
      className={`
        ${body}
        ${size === "large" ? ` ${large}` : ''}
        ${size === "medium" ? ` ${medium}` : ''}
        ${classname ? ` ${classname}` : ''}
        ${disable ? ` ${disabled}` : ''}
        ${hasArrow ? ` ${arrow}` : ''}
      `}
      onClick={() => onClick()}
    >
      {children}
    </div>
  );
}

